const NorthAmericaAddress = `
  fragment NorthAmericaAddress on CreatorContactInformationNorthAmericaAddress {
    province
    city
    zip
  }
`
export default NorthAmericaAddress
